<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" class="flex--gutter-container">
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'year' | translate }}</mat-label>

      <input type="number" matInput placeholder="{{ 'year' | translate }}" formControlName="calendarYear" data-test="edit-year-name" />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'crop' | translate }} </mat-label>

      <input
        type="text"
        [placeholder]="'crop' | translate"
        matInput
        formControlName="cropId"
        [matAutocomplete]="cropAutocomplete"
        data-test="edit-cropfield-crop"
      />

      <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
        @for (option of filteredCrops$ | async; track option) {
          <mat-option [value]="option.id" data-test="edit-cropfield-crop-option"> {{ option.name }} </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'soilType' | translate }}</mat-label>

      <mat-select formControlName="soilTypeId" placeholder="{{ 'soilType' | translate }}" data-test="edit-soilType-name">
        @for (soilType of data.soilTypes; track soilType) {
          <mat-option [value]="soilType.id">{{ soilType.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'location' | translate }}</mat-label>

      <mat-select formControlName="location" placeholder="{{ 'location' | translate }}" data-test="edit-location-name">
        @for (location of locations | keyvalue; track location) {
          <mat-option [value]="location.key">{{ getLocationString(location.key) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="mat-slide-group-wrapper">
      <div class="mat-slide-group">
        <mat-slide-toggle color="primary" formControlName="isPreviousCropCorn" data-test="edit-isPreviousCropCorn-name">
          {{ 'isPreviousCropCorn' | translate }}
        </mat-slide-toggle>
      </div>

      <div class="mat-slide-group">
        <mat-slide-toggle color="primary" formControlName="isPreviousCropNotGrain" data-test="edit-isPreviousCropNotGrain-name">
          {{ 'isPreviousCropNotGrain' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>

  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'grasslandUsage' | translate }}</mat-label>

      <mat-select formControlName="grasslandUsage" placeholder="{{ 'grasslandUsage' | translate }}" data-test="edit-location-name">
        <mat-option [value]="null">{{ 'option_none' | translate }}</mat-option>

        @for (grasslandUsage of grasslandUsages | keyvalue; track grasslandUsage) {
          <mat-option [value]="grasslandUsage.key">
            {{ getGrasslandUsageString(grasslandUsage.key) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="mat-slide-group">
      <mat-slide-toggle color="primary" formControlName="shouldSplitNorm" data-test="edit-shouldSplitNorm-name">
        {{ 'shouldSplitNorm' | translate }}
      </mat-slide-toggle>
    </div>

    <div>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cropVarietySpecificNorm' | translate }}</mat-label>

        <mat-select
          formControlName="cropVarietySpecificNorm"
          placeholder="{{ 'cropVarietySpecificNorm' | translate }}"
          data-test="edit-cropVarietySpecificNorm-name"
        >
          <mat-option [value]="null">{{ 'option_none' | translate }}</mat-option>

          @for (cropVarietySpecificNormValue of cropVarietySpecificNormValues | keyvalue; track cropVarietySpecificNormValue) {
            <mat-option [value]="cropVarietySpecificNormValue.key">
              {{ getCropVarietySpecificNormString(cropVarietySpecificNormValue.key) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto" data-test="edit-cropfield-startDateBefore">
      <mat-label>{{ 'startDateBefore' | translate }}</mat-label>

      <input matInput formControlName="startDateBefore" [matDatepicker]="startDateBeforePicker" [placeholder]="'startDateBefore' | translate" />

      <mat-datepicker-toggle matSuffix [for]="startDateBeforePicker"></mat-datepicker-toggle>

      <mat-datepicker #startDateBeforePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto" data-test="edit-cropfield-startDateAfter">
      <mat-label>{{ 'startDateAfter' | translate }}</mat-label>

      <input matInput formControlName="startDateAfter" [matDatepicker]="startDateAfterPicker" [placeholder]="'startDateAfter' | translate" />

      <mat-datepicker-toggle matSuffix [for]="startDateAfterPicker"></mat-datepicker-toggle>

      <mat-datepicker #startDateAfterPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto" data-test="edit-cropfield-endDateBefore">
      <mat-label>{{ 'endDateBefore' | translate }}</mat-label>

      <input matInput formControlName="endDateBefore" [matDatepicker]="endDateBeforePicker" [placeholder]="'endDateBefore' | translate" />

      <mat-datepicker-toggle matSuffix [for]="endDateBeforePicker"></mat-datepicker-toggle>

      <mat-datepicker #endDateBeforePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto" data-test="edit-cropfield-endDateAfter">
      <mat-label>{{ 'endDateAfter' | translate }}</mat-label>

      <input matInput formControlName="endDateAfter" [matDatepicker]="endDateAfterPicker" [placeholder]="'endDateAfter' | translate" />

      <mat-datepicker-toggle matSuffix [for]="endDateAfterPicker"></mat-datepicker-toggle>

      <mat-datepicker #endDateAfterPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto" data-test="edit-cropfield-startDatePreviousYearBefore">
      <mat-label>{{ 'startDatePreviousYearBefore' | translate }}</mat-label>

      <input
        matInput
        formControlName="startDatePreviousYearBefore"
        [matDatepicker]="startDatePreviousYearBeforePicker"
        [placeholder]="'startDatePreviousYearBefore' | translate"
      />

      <mat-datepicker-toggle matSuffix [for]="startDatePreviousYearBeforePicker"></mat-datepicker-toggle>

      <mat-datepicker #startDatePreviousYearBeforePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto" data-test="edit-cropfield-startDatePreviousYearAfter">
      <mat-label>{{ 'startDatePreviousYearAfter' | translate }}</mat-label>

      <input
        matInput
        formControlName="startDatePreviousYearAfter"
        [matDatepicker]="startDatePreviousYearAfterPicker"
        [placeholder]="'startDatePreviousYearAfter' | translate"
      />

      <mat-datepicker-toggle matSuffix [for]="startDatePreviousYearAfterPicker"></mat-datepicker-toggle>

      <mat-datepicker #startDatePreviousYearAfterPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="flex--row flex--gutter">
    <div class="mat-slide-group-wrapper spacing--margin-right">
      <div class="mat-slide-group">
        <mat-slide-toggle color="primary" formControlName="isNitrogenDifferentiation" data-test="edit-isNitrogenDifferentiation-name">
          {{ 'isNitrogenDifferentiation' | translate }}
        </mat-slide-toggle>
      </div>

      <div class="mat-slide-group">
        <mat-slide-toggle color="primary" formControlName="isAfterTornGrass" data-test="edit-isAfterTornGrass-name">
          {{ 'isAfterTornGrass' | translate }}
        </mat-slide-toggle>
      </div>
    </div>

    <div class="mat-slide-group-wrapper">
      <div class="mat-slide-group">
        <mat-slide-toggle
          color="primary"
          formControlName="isGroundWaterPreservationWithNitrogenCuts"
          data-test="edit-isGroundWaterPreservationWithNitrogenCuts-name"
          >{{ 'isGroundWaterPreservationWithNitrogenCuts' | translate }}</mat-slide-toggle
        >
      </div>

      <div class="mat-slide-group">
        <mat-slide-toggle color="primary" formControlName="isNutrientsPollutedArea" data-test="edit-isNutrientsPollutedArea-name">{{
          'isNutrientsPollutedArea' | translate
        }}</mat-slide-toggle>
      </div>
    </div>
  </div>

  <div>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'norm' | translate }}</mat-label>

      <input type="number" matInput placeholder="{{ 'norm' | translate }}" formControlName="nitrogenNorm" data-test="edit-nitrogenNorm-name" />
    </mat-form-field>
  </div>
</agr-form-dialog>
